<smrts-dialog title="Novo papel" [hasFootnote]="true">

  <div class="content">
    <p-floatlabel variant="on">
      <input pInputText id="nome" type="text" [(ngModel)]="nome" style="width: 100%;" />
      <label for="nome">Nome do papel</label>
    </p-floatlabel>

    <p-floatlabel variant="on">
      <textarea pInputTextarea id="descricao" [(ngModel)]="descricao"
        style="width: 100%;" rows="3" [autoResize]="true"></textarea>
      <label for="descricao">Descrição (opcional)</label>
    </p-floatlabel>
  </div>

  <div footnote class="footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="null">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="salvarClick()" [disabled]="salvando">
      Salvar
    </button>
  </div>

</smrts-dialog>
